import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearPgMeta,
  GetStaticPgMeta,
  useStaticPgMeta,
} from "../../../redux/slices/staticPgMetaSlice";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Form,
} from "reactstrap";
import { IoFilterOutline } from "react-icons/io5";
import { Switch } from "@mui/material";
import { Table, TableRow } from "../../../components/Table";
import { responseToaster } from "../../../helperFunctions";
import { useForm } from "react-hook-form";
import { TRA_PAGINATION_OPTIONS } from "../../../constant";
import { useRole } from "../../../redux/slices/authSlice";
import ControlledDropDown from "../../../components/Custom/Forms/Controller/ControlledDropDown";
import {
  Filter_Data_Transaction,
  PaymentMetaLabelListGet,
} from "../../../redux/slices/transactionSlice";
import ChangeBankModal from "../../../components/Custom/Modals/ChangeBankModal/ChangeBankModal";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const StaticPgMeta = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.staticPgMeta);
  const { transactionFilterState, paymentMetaLabelListGetData } = useSelector(
    (state) => state.transaction
  );
  const [showTableData, setShowTableData] = useState(false)
  const [data, setData] = useState({});
  const getStaticPgMetaState = useStaticPgMeta();

  const [isViewsendDataModal, setIsViewsendDataModal] = useState(false);
  const [loading, setLoading] = useState({
    pgLoading: false,
    pgAccLoading: false,
  });

  const initialValues = {
    isFilter: false,
    page_no: 1,
    limit: 100,
    pgName: "",
    pgId: "",
  };

  const [filter, setFilter] = useState(initialValues);
  const [filterColumns, setFilterColumns] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const role = useRole("Static Pg Meta");

  const schema = Yup.object({
    pgName: Yup.string().required("PG Name Is Required"),
  });

  const {
    control,
    handleSubmit,
    getValues,
    reset,
    setValue,
    resetField,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(schema),
  });

  const columns = [
    {
      title: "id",
      name: "merchant_id",
    },
    {
      title: "Merchant Name",
      name: "admin_merchant_name",
      Cell: (data) => <>{data?.merchant_details?.admin_merchant_name}</>,
    },
    {
      title: "total customer",
      name: "total_customer",
    },
    {
      title: "Action",
      name: "action",
      Cell: (data) => {
        return (
          <>
            <Button
              color="primary"
              className="btn-smallsize"
              style={{ backgroundColor: "var(--chatlook-darkblue--)" }}
              onClick={() => setIsViewsendDataModal(data)}
            >
              Change Bank
            </Button>
          </>
        );
      },
    },
  ];
  const columnsForPg = [
    {
      title: "id",
      name: "account_id",
      Cell: (data) => <>{data?.bank_details?.account_id}</>,
    },
    {
      title: "label",
      name: "label",
      Cell: (data) => <>{data?.bank_details?.label}</>,
    },
    {
      title: "total customer",
      name: "total_customer",
    },
    {
      title: "Action",
      name: "action",
      Cell: (data) => {
        return (
          <>
            <Button
              color="primary"
              className="btn-smallsize"
              style={{ backgroundColor: "var(--chatlook-darkblue--)" }}
              onClick={() => setIsViewsendDataModal(data)}
            >
              Change Bank
            </Button>
          </>
        );
      },
    },
  ];

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const onCloseModal = (data) => {
    setData(data);
    setIsViewsendDataModal(!isViewsendDataModal);
  };

  const getFilterTransactions = async () => {
    try {
      setLoading({ ...loading, pgLoading: true });
      await dispatch(Filter_Data_Transaction()).unwrap();
      setLoading({ ...loading, pgLoading: false });
    } catch (err) { }
  };

  const PaymentMetaLabelList = async () => {
    try {
      const pgName = transactionFilterState?.pg_data?.find((data) => {
        return data?.pg_id == watch("pgName");
      });
      let payload = {
        pgType: "payin",
        pgName: pgName?.pg_name ? [pgName?.pg_name] : "All",
        pg_id: watch("pgName") || "all",
      };
      setLoading({ ...loading, pgAccLoading: true });
      await dispatch(PaymentMetaLabelListGet(payload)).unwrap();
      setLoading({ ...loading, pgAccLoading: false });
    } catch (e) { }
  };

  useEffect(() => {
    getFilterTransactions();
  }, []);

  useEffect(() => {
    if (watch("pgName")) {
      PaymentMetaLabelList();
    }
  }, [watch("pgName")]);

  const preparepgDataOptions = () => {
    const options = transactionFilterState?.pg_data
      ?.slice()
      ?.sort((a, b) => a?.pg_name?.localeCompare(b?.pg_name))
      ?.map((val) => {
        const pgDataOption = { value: val?.pg_id, label: val?.pg_name };

        return pgDataOption;
      });
    return options;
  };

  const getpgAccDataOptions = () => {
    const options = paymentMetaLabelListGetData?.data
      ?.slice()
      ?.sort((a, b) => a?.note?.localeCompare(b?.note))
      ?.map((val) => {
        const pgAccDataOption = { value: val?.acId, label: val?.note };
        return pgAccDataOption;
      });
    return options;
  };

  const Get_Static_Meta = async () => {
    try {
      const { page_no, limit, pgId, pgName: pgName1 } = filter;
      const pgName = transactionFilterState?.pg_data?.find?.((data) => {
        return data?.pg_id == pgName1;
      });
      const payload = {
        filter_data: {
          pgId,
          pgName: pgName?.pg_name,
        },
        page_no,
        limit,
      };

      const res = await dispatch(GetStaticPgMeta(payload)).unwrap();
      if (res?.status) {
        setShowTableData(!!pgId)
      }
      if (filter?.isFilter) {
        responseToaster(res);
      }
    } catch (err) { }
  };

  useEffect(() => {
    const newColumns = (!showTableData ? columnsForPg : columns)
      ?.map((item) => item?.name);

    setFilterColumns(newColumns);
  }, [showTableData]);

  useEffect(() => {
    if (role.includes("static-pg-meta-list") && filter?.isFilter) {
      Get_Static_Meta();
    }
  }, [filter]);

  const onSubmit = async () => {
    const values = getValues();
    setFilter({
      ...filter,
      ...values,
      isFilter: true,
    });
  };
  return (
    <>
      {role.includes("static-pg-meta-list") ? (
        <>
          <div className="support-log-main-div">
            <Card>
              <CardHeader className="flex-column  align-items-start">
                <div className="d-flex align-items-center w-100 justify-content-between">
                  <div>
                    <h4 className="main-title">
                      <b>Static Pg Meta</b>
                    </h4>
                  </div>

                  <div className="d-flex">
                    <Dropdown isOpen={isOpen} toggle={toggleDropdown}>
                      <DropdownToggle
                        className=" header-item waves-effect border-0 bg-transparent table-filterbtn"
                        id="page-header-user-dropdown"
                        tag="button"
                      >
                        <IoFilterOutline fill="#7367F0" />
                      </DropdownToggle>
                      <DropdownMenu
                        className="z-3"
                        style={{
                          whiteSpace: "nowrap",
                          padding: 20,
                          transform: "translate(-20px, 22px)",
                        }}
                      >
                        <li className="z-3 text-dark">
                          <span>
                            <i className="fa-solid fa-filter"></i> Filter Column
                          </span>
                        </li>
                        <div className="border-bottom border-light mt-2">
                          {(!showTableData ? columnsForPg : columns)
                            ?.map?.((column) => {
                              return (
                                <div className="d-flex justify-content-between">
                                  <p>{column?.title}</p>
                                  <Switch
                                    checked={filterColumns?.includes(
                                      column?.name
                                    )}
                                    size="small"
                                    onChange={(e) => {
                                      const newData = [...filterColumns];
                                      const index = newData?.indexOf(
                                        column?.name
                                      );
                                      if (index > -1) {
                                        newData.splice(index, 1);
                                      } else {
                                        newData.push(column?.name);
                                      }
                                      setFilterColumns(newData);
                                    }}
                                  />
                                </div>
                              );
                            })}
                        </div>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="d-flex align-items-end justify-content-between">
                <Form
                  className="d-flex my-xl-auto right-content align-items-start button-space"
                  style={{ flexWrap: "wrap" }}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <ControlledDropDown
                    label="PG"
                    name="pgName"
                    isDefaultOption={false}
                    options={preparepgDataOptions()}
                    onChange={(e) => {
                      setValue("pgName", e?.value);
                      resetField("pgId");
                      if (e?.value) {
                        clearErrors("pgName");
                      }
                    }}
                    isLoading={loading?.pgLoading}
                    isDisabled={loading?.pgLoading}
                    control={control}
                    errors={errors}
                  />
                  <ControlledDropDown
                    label="PG Account"
                    name="pgId"
                    isDefaultOption={false}
                    isLoading={loading?.pgAccLoading}
                    isDisabled={loading?.pgAccLoading}
                    options={getpgAccDataOptions()}
                    control={control}
                    errors={errors}
                  />
                  <div
                    style={{ marginTop: "28px" }}
                    className="d-flex button-space"
                  >
                    <Button type="submit" color="primary">
                      Apply
                    </Button>
                    <Button
                      type="button"
                      color="danger"
                      onClick={() => {
                        reset();
                        setFilter({ ...initialValues });
                        dispatch(clearPgMeta({}));
                        setShowTableData(false)
                      }}
                    >
                      Clear
                    </Button>
                  </div>
                </Form>
                {filter?.isFilter &&
                  !!getStaticPgMetaState?.data?.length &&
                  !isLoading ? (
                  <Button
                    color="primary"
                    style={{ backgroundColor: "var(--chatlook-darkblue--)" }}
                    onClick={() => onCloseModal(data)}
                  >
                    Change Bank
                  </Button>
                ) : null}
              </CardBody>
            </Card>
            <Card>
              <Table
                columns={
                  !showTableData
                    ? columnsForPg
                    : columns
                }
                isLoading={isLoading}
                data={getStaticPgMetaState?.data || []}
                isData={!!getStaticPgMetaState?.data?.length}
                filterColumns={filterColumns}
                isExpandable={false}
                paginationOptions={TRA_PAGINATION_OPTIONS}
                pagination={filter}
                count={getStaticPgMetaState?.total_item || 0}
                handlePaginationChange={(pagination) => {
                  setFilter({
                    ...filter,
                    ...pagination,
                  });
                }}
              >
                {getStaticPgMetaState?.data?.map?.((item) => {
                  return (
                    <TableRow
                      columns={
                        !showTableData
                          ? columnsForPg
                          : columns
                      }
                      item={item}
                      filterColumns={filterColumns}
                      isExpandable={false}
                    />
                  );
                })}
              </Table>
            </Card>
          </div>
          <ChangeBankModal
            changeBankModal={isViewsendDataModal}
            onCloseChangeBankModal={() => onCloseModal()}
            onGet={() => Get_Static_Meta()}
            merchants={getStaticPgMetaState?.data}
            bankId={watch("pgId")}
            bankName={watch("pgName")}
            bankOptions={getpgAccDataOptions()}
            paymentMetaLabelList={PaymentMetaLabelList}
            paymentMetaLabelListGetData={paymentMetaLabelListGetData}
            preparepgDataOptions={preparepgDataOptions()}
            getpgAccDataOptions={getpgAccDataOptions()}
            showTableData={showTableData}
          />
        </>
      ) : null}
    </>
  );
};

export default StaticPgMeta;
